import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-165359f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer-button" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "opacity-area" }, null, -1 /* HOISTED */))
const _hoisted_3 = { class: "base-button-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode($setup["BaseButton"], {
        class: "base-button",
        title: $props.title,
        onOnClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onClickFooterButton'))),
        disabled: $props.disabled
      }, null, 8 /* PROPS */, ["title", "disabled"])
    ])
  ]))
}